import { TranslationMessages } from '../types';
import { app } from './app/fr';
import { settingsApp } from './app/fr';

const fr: TranslationMessages = {
  "nav": {
    "howItWorks": "Comment ça marche",
    "why": "Pourquoi ?",
    "features": "Fonctionnalités",
    "getStarted": "COMMENCER",
    "dashboard": "Tableau de bord",
    "blog": "Blog"
  },
  "hero": {
    "title1": "Telegram Stars",
    "title2": "Soyez payé facilement",
    "subtitle": "Créez des liens de paiement instantanément, gérez votre solde et retirez en TON. Frais de plateforme 3 %.",
    "cta": "Commencer",
    "hairsim": "Simuler votre greffe de cheveux"
  },
  "demo": {
    "botName": "Telegram Stars Bot",
    "online": "en ligne",
    "linkCreated": "Lien de paiement créé.",
    "invoiceTitle": "Premium Access",
    "invoiceDesc": "Abonnement mensuel",
    "stars": "Stars",
    "payBtn": "Payer 100 Stars",
    "iPayNow": "Je paie maintenant",
    "paymentLabel": "Paiement Telegram Stars",
    "merchant": "Marchand",
    "amount": "Montant",
    "confirmPay": "Confirmer le paiement",
    "paymentReceived": "Paiement reçu — 100 Stars",
    "invoiceCredited": "Invoice #xk9m2 · crédité sur le solde",
    "thanks": "Merci, accès activé",
    "messagePlaceholder": "Message"
  },
  "stats": {
    "title": "La confiance de milliers d’agents",
    "subtitle": "Rejoignez une communauté de marchands qui utilisent les paiements Telegram Stars",
    "activeAgents": "Agents actifs",
    "transactions": "Transactions",
    "uptime": "Disponibilité",
    "support": "Support"
  },
  "features": {
    "title": "Tout pour accepter les paiements Telegram Stars",
    "subtitle": "Une plateforme complète pour gérer vos paiements Telegram Stars",
    "instantTitle": "Création instantanée",
    "instantDesc": "Devenez agent en quelques secondes. Aucune configuration requise.",
    "balanceTitle": "Gestion du solde",
    "balanceDesc": "Suivez vos revenus en temps réel avec un tableau de bord intuitif.",
    "paymentsTitle": "Paiements Telegram Stars",
    "paymentsDesc": "Acceptez les paiements en Telegram Stars via votre bot.",
    "securityTitle": "Sécurité maximale",
    "securityDesc": "Ledger immuable, transactions sécurisées et transparentes.",
    "withdrawTitle": "Retraits TON",
    "withdrawDesc": "Retirez vos fonds directement vers votre adresse TON.",
    "apiTitle": "API robuste",
    "apiDesc": "Intégration facile avec webhooks et une API REST complète."
  },
  "how": {
    "title": "Comment ça marche",
    "subtitle": "Démarrez en 3 étapes simples",
    "startDemo": "Lancer la démo",
    "demoRunning": "Démo en cours...",
    "reset": "Réinitialiser",
    "step1Title": "1. Inscription",
    "email": "Email",
    "password": "Mot de passe",
    "noCard": "✓ Aucune carte bancaire requise",
    "step2Title": "2. Créer des liens de paiement",
    "amountStars": "Montant (Stars)",
    "generatedLink": "Lien généré :",
    "shareLink": "✓ Partagez ce lien avec vos clients",
    "step3Title": "3. Retirer vos fonds",
    "tonAddress": "Adresse TON",
    "availableBalance": "Solde disponible :",
    "fee": "Frais : 3 %"
  },
  "pricing": {
    "title": "Tarification simple et transparente",
    "subtitle": "Pas de frais cachés, sans engagement",
    "commission": "Commission",
    "perTransaction": "par transaction",
    "freeAccount": "Création de compte gratuite",
    "noMonthly": "Pas de frais mensuels",
    "tonWithdrawals": "Retraits TON intégrés",
    "completeDashboard": "Tableau de bord complet",
    "support247": "Support 24/7",
    "startNow": "Commencer maintenant"
  },
  "faq": {
    "title": "Questions fréquentes",
    "subtitle": "Tout ce qu’il faut savoir sur les paiements Telegram Stars",
    "q1": "Comment fonctionne le paiement Telegram Stars ?",
    "a1": "Les marchands créent des liens de paiement, les partagent avec leurs clients, et reçoivent les paiements en Telegram Stars.",
    "q2": "Quels sont les frais de la plateforme ?",
    "a2": "Les frais sont de 3 % par transaction. Aucun frais d’installation ni coût mensuel.",
    "q3": "Comment retirer mes Telegram Stars ?",
    "a3": "Vous pouvez demander un retrait vers votre portefeuille TON. Minimum : 100 Stars.",
    "q4": "Le paiement Telegram Stars est-il sécurisé ?",
    "a4": "Oui, tous les paiements passent par le système sécurisé de Telegram, avec chiffrement standard.",
    "q5": "Que sont les Telegram Stars ?",
    "a5": "Les Telegram Stars sont une monnaie virtuelle utilisée dans Telegram pour payer des services, produits et abonnements.",
    "q6": "Puis-je utiliser Telegram Stars pour mon activité ?",
    "a6": "Oui ! La plateforme est conçue pour les marchands, créateurs et entreprises."
  },
  "cta": {
    "title": "Prêt à commencer ?",
    "subtitle": "Rejoignez des milliers d’agents qui utilisent déjà notre plateforme",
    "createAccount": "Créer un compte gratuit",
    "signIn": "Se connecter"
  },
  "footer": {
    "description": "Plateforme SaaS complète pour les paiements Telegram Stars",
    "product": "Produit",
    "features": "Fonctionnalités",
    "pricing": "Tarifs",
    "support": "Support",
    "signIn": "Se connecter",
    "docs": "Documentation",
    "copyright": "© 2024 Telegram Stars Payment Platform. Tous droits réservés."
  },
  "seo": {
    "title": "Plateforme de paiement Telegram Stars | Acceptez les paiements en Stars",
    "description": "Acceptez les paiements via Telegram Stars. Créez des liens instantanément, gérez votre solde et retirez en TON. Frais 3 %.",
    "keywords": "paiement telegram stars, accepter telegram stars, plateforme paiement telegram stars"
  },
  "whyPage": {
    "seoTitle": "Pourquoi choisir Telegram Stars Payment Platform",
    "seoDescription": "Découvrez pourquoi les marchands choisissent notre plateforme : configuration instantanée, tarifs transparents, paiements sécurisés.",
    "title": "Pourquoi nous choisir ?",
    "subtitle": "Conçu pour les marchands et créateurs qui veulent des paiements Telegram Stars simples",
    "r1Title": "Configuration instantanée",
    "r1Desc": "Démarrez en quelques secondes. Aucune configuration complexe.",
    "r2Title": "Tarifs transparents",
    "r2Desc": "Seulement 3 % par transaction. Pas de frais cachés.",
    "r3Title": "Sécurisé et fiable",
    "r3Desc": "Basé sur l’infrastructure de paiement sécurisée de Telegram.",
    "r4Title": "Portée mondiale",
    "r4Desc": "Acceptez des paiements d’utilisateurs Telegram partout dans le monde.",
    "r5Title": "Intégration facile",
    "r5Desc": "API et webhooks simples. Intégrez vos systèmes en quelques minutes.",
    "r6Title": "Retraits TON",
    "r6Desc": "Retirez directement vers votre portefeuille TON."
  },
  "howPage": {
    "seoTitle": "Comment ça marche | Telegram Stars Payment Platform",
    "seoDescription": "Apprenez à accepter les paiements Telegram Stars en 3 étapes simples.",
    "title": "Comment ça marche",
    "subtitle": "Acceptez les paiements Telegram Stars en trois étapes simples"
  },
  "settings": {
    "title": "Paramètres",
    "languageSection": "Langue",
    "defaultLanguage": "Langue par défaut",
    "languageHint": "Cette langue s’applique à toute la plateforme (pages vitrine et interface).",
    "languageSaved": "Langue mise à jour",
    ...settingsApp,
  },
  app,
};

export default fr;
